export const SCRIPT_URL = 'https://service-gateway.qualie.com/core/api/testimonials/embed/3DV2aOrBRD';